import { GenericResult } from '../../components';
import { useTranslation } from 'react-i18next';

export const PageNotFound = () => {
  const { t } = useTranslation();

  return <GenericResult status="404" title={t('common.pageNotFound')} />;
};
